import { translate } from 'infras/i18n';
import { TaskListItem } from 'presentations/api/schema/task';

export function tasksName(task: TaskListItem) {
  if (!task) return '';
  let taskName = task.name;
  if (task.isDefaultAdd && taskName.startsWith('tutorial.')) {
    taskName = translate(taskName);
  }
  return taskName;
}
